import { DAILY_ALLOWANCE } from "../constants";

export function decreaseAllowance({ internals }: any) {
  internals.setState(
    {
      ...internals.state,
      limit: {
        ...internals.state.limit,
        remaining: (internals.state.limit?.remaining ?? DAILY_ALLOWANCE) - 1,
      },
    },
    { permanent: true }
  );
}
